import { useState, useEffect, useContext } from 'react';
import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { MeContext } from '../../../context/MeContext';

const STORAGE_KEY = 'banner_shape_wizard_seen';

const wasSeen = (accountId: string): boolean => {
  try {
    return localStorage.getItem(`${STORAGE_KEY}_${accountId}`) === '1';
  } catch {
    return false;
  }
};

const markSeen = (accountId: string): void => {
  try {
    localStorage.setItem(`${STORAGE_KEY}_${accountId}`, '1');
  } catch (e) {
    console.error('Failed to save banner shape wizard dismissal:', e);
  }
};

interface BannerShapeWizardProps {
  visible: boolean;
}

const BannerShapeWizard = ({ visible }: BannerShapeWizardProps) => {
  const meCtx = useContext(MeContext) as {
    state: { account?: { id?: string | number } | null };
  } | undefined;
  const accountId =
    meCtx?.state?.account?.id != null
      ? String(meCtx.state.account.id)
      : undefined;

  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!visible || !accountId) return;
    if (!wasSeen(accountId)) {
      const timer = setTimeout(() => setShow(true), 400);
      return () => clearTimeout(timer);
    }
  }, [visible, accountId]);

  const dismiss = () => {
    setShow(false);
    if (accountId) markSeen(accountId);
  };

  if (!show) return null;

  return (
    <Box
      position="absolute"
      bottom="249px"
      left="-12px"
      zIndex={3}
      bg="#1D2B36"
      borderRadius="10px"
      maxW="230px"
      boxShadow="0px 3px 3px rgba(0,0,0,0.1), 0px 10px 10px rgba(0,0,0,0.1), 0px 15px 15px rgba(0,0,0,0.15)"
      p={4}
      _after={{
        content: '""',
        position: 'absolute',
        bottom: '-10px',
        left: '94px',
        borderWidth: '10px 8px 0 8px',
        borderStyle: 'solid',
        borderColor: '#1D2B36 transparent transparent transparent',
      }}
    >
      <Flex direction="column" gap={2}>
        <Text textStyle="bodyFamilySemiBold" fontSize="14px" color="white" lineHeight="1.4">
          Choose banner shape
        </Text>
        <Text fontSize="12px" color="white" lineHeight="1.5">
          Google banners now support two shapes: wide (3:1) or squarer (5:4). Click the ratio to switch.
        </Text>
        <Button
          size="xs"
          alignSelf="flex-end"
          mt={1}
          px={3}
          py={1}
          h="30px"
          borderRadius="5px"
          variant="gradient"
          fontSize="12px"
          _hover={{ opacity: 0.9 }}
          onClick={dismiss}
        >
          Got it
        </Button>
      </Flex>
    </Box>
  );
};

export default BannerShapeWizard;
